<app-page-header>
  <span class="page-title"><h3>Interactive Video</h3></span>
</app-page-header>
<div class="row">
  <div class="col-auto" [ngClass]="{ 'hide-listwrapper': viewClassRoomList }">
    <div
      class="col se-p second-level-menu is-notification right-box-shadow scroll-bar"
    >
      @if (showSearchSec) {
      <div class="menu-options level is-marginless display-flex">
        <div class="level-left">
          <div class="level-item">
            <div class="select is-small">
              <select [(ngModel)]="sortBy" (change)="getStudyRoom(0)">
                <option value="title">Sort A to Z</option>
                <option value="time">Sort by Recent</option>
              </select>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a class="button is-small" (click)="showSearchBox('open')">
              <i class="fa fa-search"></i>
            </a>
          </div>
        </div>
      </div>
      } @if (!showSearchSec) {
      <div class="menu-options level is-marginless searchBox-pad display-flex">
        <div class="level-left">
          <div class="level-item input-search-box">
            <div class="field">
              <p class="control has-icons-left has-icons-right">
                <input
                  type="text"
                  class="input"
                  inputFocus
                  [(ngModel)]="search"
                  (keyup)="searchInList.next($event)"
                  placeholder="Search here..."
                />
                <a class="icon is-small is-left" title="search">
                  <i class="fa fa-search"></i>
                </a>
                <span class="input-bar"></span>
              </p>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <span
              class="icon is-small is-right search-return"
              (click)="showSearchBox('close')"
            >
              <i class="fa fa-times-circle"></i>
            </span>
          </div>
        </div>
      </div>
      }
      <div
        class="list-wrapper scroll-bar list-overflow"
        appInfiniteScrollDistance
        infinite-scroll
        [scrollWindow]="false"
        [infiniteScrollDistance]="modalScrollDistance"
        [infiniteScrollThrottle]="modalScrollThrottle"
        (scrolled)="fetchNextClassRoomList()"
      >
        <ul class="notification-list">
          @for (group of getClassRoomList; track group) {
          <li
            class="cursor-pointer pos-relative chat-list"
            routerLinkActive="active"
          >
            <div
              class="columns is-gapless is-clearfix pos-relative display-flex"
              [routerLink]="['/videoquiz', group.group_id]"
            >
              <div class="column is-one-quarter">
                @if (group.group_icon) {
                <img [src]="profileUrl + group.group_icon" />
                } @if (!group.group_icon) {
                <empty-uname
                  [userName]="group.full_name"
                  [liProfile]="true"
                ></empty-uname>
                }
              </div>
              <div class="column is-clearfix">
                <p class="list-active">
                  <a
                    class="has-tooltip-top"
                    data-tooltip="{{ group.full_name }}"
                    placement="top"
                  >
                    {{
                      group.full_name.length > 20
                        ? (group.full_name | slice : 0 : 20) + " ..."
                        : group.full_name
                    }}</a
                  >
                </p>
                <!-- <span class="badge-count" *ngIf="group.unread_post_count">{{group.unread_post_count}}</span> -->
              </div>
            </div>
          </li>
          }
          <pagination-loader
            [showFetchLoader]="showPaginateSpinner"
          ></pagination-loader>
        </ul>
      </div>
    </div>

    @if (totalClassListCount === 0) {
    <div class="empty-state">
      <div class="has-text-centered box">
        <img [src]="'../../../../assets/images/notification_empty.svg'" />
        <p>No lesson room List found</p>
      </div>
    </div>
    }
  </div>
  <div class="col ps-0" [ngClass]="{ 'ps-3': viewClassRoomList }">
    <router-outlet></router-outlet>
  </div>
</div>
